import Api from 'components/Api';
import Permission from 'components/ui/security/Permission';
import BimEventBus from 'BimEventBus';
import { Validations } from 'components/ui/FormUtils';

class CeDataHidden {
  state = {
    promise: Promise.resolve(),
    initialized: false,
    requested: false,
    init: {
      key: null,
      listeners: [],
    },
  };

  context = {};

  lockInit = () => {
    this.state.init.key = `${Date.now()}${Math.random()}`;
    return {
      key: this.state.init.key,
      release: () => {
        this.state.init.key = null;
      },
    };
  };

  initCeData = (context, prefetchedTranslations, initKey) => {
    if (this.state.requested && !this.state.initialized) {
      return this.state.promise;
    }

    if (this.state.initialized) {
      return Promise.resolve(this);
    }

    if (this.state.init.key && this.state.init.key !== initKey) {
      return new Promise((resolve) => {
        this.state.init.listeners.push(() => resolve(this));
      });
    }

    this.state.requested = true;
    this.state.promise = new Promise(async (resolve, reject) => {
      try {
        const msg = await Api.translations(prefetchedTranslations);

        if (!context) {
          if (window.__ceDateInitialState) {
            context = window.__ceDateInitialState; // Mobile/Publisher
          }
        }

        this.initialize(context, msg);

        this.state.initialized = true;
        resolve(this);
        this.notifyListeners();
        this.state.init.listeners.forEach((listener) => listener());
        this.state.init.listeners = [];
      } catch (e) {
        console.error(e);
        reject(e);
      } finally {
        this.state.requested = false;
        this.state.init.key = null;
      }
    });

    return this.state.promise;
  };

  initialize(context = {}, msg) {
    console.log('CeData: init state');

    this.context = context || {};
    this.enhanceContext();

    this.context.msg = msg;
    Validations.initialize(msg);
  }

  update(context) {
    this.context = Object.assign({}, this.context, context);
    this.enhanceContext();
    this.notifyListeners();
    return this.context;
  }

  notifyListeners() {
    BimEventBus.emit('CeDataInitialized', { ceData: this });
  }

  enhanceContext() {
    this.context.contextPath = Api.baseUrl();
    this.context.execute = (exp) => Api.executeExp(exp);
    this.context.findProjectIdFromContext = () => {
      let projectId = _.get(this.context, 'project.id');
      if (!projectId) {
        projectId = _.get(this.context, 'store.currentProject.id');
      }
      return projectId;
    };

    if (this.context.user) {
      this.context.permissions = new Permission({
        user: this.context.user,
        role: this.context.userRole,
        permissions: this.context.rolePermissions,
        userIsOnlyCockpit: this.context.userIsOnlyCockpit,
        labs: this.context.labs,
        bimResources: this.context.bimResources,
      });
    }
  }
}

export const ceData = new CeDataHidden();
